export const ARTICLE9_CONFIG = {
  article9a: {
    question:
      "Entitatea este singurul furnizor al unui serviciu care este esențial pentru susținerea unor activități societale și economice critice.",
    tooltip:
      "Se verifică dacă entitatea este unicul furnizor al unui serviciu critic, fără alternative disponibile sau suficiente pe piață.",
  },
  article9b: {
    question:
      "Perturbarea serviciului furnizat de entitate ar putea avea un impact semnificativ asupra siguranței publice, a securității publice sau a sănătății publice.",
    tooltip:
      "Se evaluează impactul potențial asupra: siguranței publice (protecție fizică), securității publice (ordine publică, apărare națională) sau sănătății publice.",
  },
  article9c: {
    question:
      "Perturbarea serviciului furnizat de entitate ar putea genera un risc sistemic semnificativ, în special pentru sectoarele în care o astfel de perturbare ar putea avea un impact transfrontalier.",
    tooltip:
      "Se evaluează dacă perturbarea ar putea cauza efecte de contaminare transsectoriale sau transfrontaliere, afectând mai multe sectoare sau state membre.",
  },
  article9d: {
    question:
      "Entitatea este critică datorită importanței sale specifice la nivel național sau regional pentru sectorul sau tipul de servicii în cauză sau pentru alte sectoare interdependente.",
    tooltip:
      "Se evaluează importanța specifică a entității la nivel național sau regional, chiar dacă nu îndeplinește criteriile de dimensiune standard.",
  },
} as const;
